// Password Policy Module
import { api } from '../core/api-client.js';
import { showNotification } from '../utils/notifications.js';
import { hasPermission } from '../utils/permissions.js';

export async function loadPasswordPolicy() {
    if (!hasPermission('view:settings')) {
        console.log('[PasswordPolicy] No permission to view password policy');
        return;
    }

    try {
        const policy = await api.getPasswordPolicy();
        console.log('[PasswordPolicy] Loaded:', policy);
        updatePasswordPolicyUI(policy);
    } catch (error) {
        console.error('[PasswordPolicy] Failed to load:', error);
        showNotification('Failed to load password policy', 'error');
    }
}

function updatePasswordPolicyUI(policy) {
    try {
        Object.keys(policy).forEach(key => {
            const input = document.querySelector(`[name="${key}"]`);
            if (input) {
                if (input.type === 'checkbox') {
                    input.checked = policy[key] === true || policy[key] === 'true';
                } else {
                    input.value = policy[key];
                }
            }
        });
    } catch (error) {
        console.error('[PasswordPolicy] Error updating UI:', error);
    }
}

export async function handleSavePasswordPolicy(e) {
    e.preventDefault();

    try {
        const form = e.target;
        const formData = new FormData(form);
        const policy = {};

        const saveBtn = form.querySelector('button[type="submit"]');
        const originalBtnText = saveBtn.innerHTML;
        saveBtn.disabled = true;
        saveBtn.innerHTML = '<i class="fas fa-spinner fa-spin mr-2"></i>Saving...';

        for (let [key, value] of formData.entries()) {
            const input = form.elements[key];
            if (input.type === 'checkbox') {
                policy[key] = input.checked;
            } else if (input.type === 'number') {
                policy[key] = parseInt(value);
            } else {
                policy[key] = value;
            }
        }

        await api.updatePasswordPolicy(policy);
        showNotification('Password policy saved successfully!', 'success');

        saveBtn.disabled = false;
        saveBtn.innerHTML = originalBtnText;
    } catch (error) {
        console.error('[PasswordPolicy] Failed to save:', error);
        showNotification('Failed to save password policy: ' + error.message, 'error');

        const saveBtn = e.target.querySelector('button[type="submit"]');
        if (saveBtn) {
            saveBtn.disabled = false;
            saveBtn.innerHTML = '<i class="fas fa-save mr-2"></i>Save Policy';
        }
    }
}

window.handleSavePasswordPolicy = handleSavePasswordPolicy;
window.loadPasswordPolicy = loadPasswordPolicy;
